import { useContext, useEffect, useState } from 'react';
import { appAuthContext } from '../context/AuthContext';

const useFormattedName = () => {
  const { user } = useContext(appAuthContext);
  const [formattedName, setFormattedName] = useState('');

  useEffect(() => {
    if (!user?.data?.attributes) return setFormattedName('');

    const firstName = user?.data.attributes?.name;
    const lastName = user?.data.attributes?.last_name || '';
    const middleName = user?.data.attributes?.middle_name || '';

    if (user?.data?.type === 'student') {
      setFormattedName(`${firstName} ${lastName ? `${lastName[0]}.` : ''}`);
    } else {
      setFormattedName(`${firstName} ${middleName} ${lastName}`);
    }
  }, [user]);

  return formattedName;
};

export default useFormattedName;
